import axios, {CancelTokenSource} from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {AXIOS_CANCEL_MSG, Truck,} from '../api/models';
import { ConfiguratorContext } from '../context';

interface TruckProps {
  serialNumber?:string | undefined
}

export const useTruck = (props: TruckProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:TruckProps  ) : Promise<Truck | undefined> => {

    const { serialNumber } = props;
    if (!serialNumber ) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp =  await configurator.api.fetchTruck(serialNumber, cancelSource?.token);

      cancelTokenSourceRef.current = undefined;
      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
        'fetchTruck',
        props
      ],
      ([_k, p]) => fetcher(p),
      {
        shouldRetryOnError: false,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        revalidateOnMount: true,
        dedupingInterval:1
    }
  );
};


export default useTruck;

